import { RootState } from '../reducers/rootReducer';

export const getCameraState = (state: RootState) => state.camera;
export const getCameraScript = (state: RootState) => getCameraState(state).script;
export const getCameraScriptRaw = (state: RootState) => getCameraState(state).rawScript;
export const getCameraLoading = (state: RootState) => getCameraState(state).loading;
